module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "temp-login-wrapper"
    }
  }, [_c('seo-title', {
    attrs: {
      "content": _vm.$t('login.meta.title')
    }
  }), _vm._v(" "), _c('seo-description', {
    attrs: {
      "content": _vm.$t('login.meta.description')
    }
  }), _vm._v(" "), _c('seo-author', {
    attrs: {
      "content": "Deveo ApS"
    }
  }), _vm._v(" "), _c('seo-og-title', {
    attrs: {
      "content": _vm.$t('login.meta.title')
    }
  }), _vm._v(" "), _c('seo-og-description', {
    attrs: {
      "content": _vm.$t('login.meta.description')
    }
  }), _vm._v(" "), _c('seo-og-image', {
    attrs: {
      "content": "/static/images/opengraph/fb_og.png"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "main-cont"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('login.header')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('login.text')))]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-light btn-rounded",
    attrs: {
      "to": {
        name: 'Index'
      },
      "tag": "a"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('login.button')) + "\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd1ee1cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/login/pages/index.vue
// module id = 317
// module chunks = 1